export enum DocumentModelState {
	ACTIVE = 'ACTIVE',
	ARCHIVED = 'ARCHIVED'
}
